import React from 'react';
import { MiniappSdkContext } from 'components/miniapp-sdk-provider/miniapp-sdk.context';
import { SDK_APP_UUID } from 'shared/consts';
import { getMiniappSdkClient } from 'hooks/use-miniapp-sdk.hook';

interface MiniappSdkProviderProps {
  children: React.ReactNode;
}

export const MiniappSdkProvider = ({ children }: MiniappSdkProviderProps): JSX.Element => {
  const miniappSdkClient = getMiniappSdkClient(SDK_APP_UUID);

  return <MiniappSdkContext.Provider value={miniappSdkClient}>{children}</MiniappSdkContext.Provider>;
};
